import React from "react";
import { useTranslation } from "react-i18next";
import { ReportsView } from "../features/reports/ReportsView";
import { withRestaurantId } from "../shared/components/layout";

const ReportsViewWithId = withRestaurantId(ReportsView);

const ReportsPage: React.FC = () => {
  const { t } = useTranslation();

  return <ReportsViewWithId />;
};

export default ReportsPage;
